module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_nursing_sp-7261df3c2a87b75532883dcc130fa275.svg";